import { render, staticRenderFns } from "./Register.vue?vue&type=template&id=1d4e2f25&scoped=true&"
import script from "./Register.vue?vue&type=script&lang=js&"
export * from "./Register.vue?vue&type=script&lang=js&"
import style0 from "./Register.vue?vue&type=style&index=0&id=1d4e2f25&prod&lang=less&scoped=true&"
import style1 from "../../assets/h5-auth.less?vue&type=style&index=1&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d4e2f25",
  null
  
)

export default component.exports